<template>
    <v-container class="fill-height" style="display: block;" fluid>

        <div id="ag-grid-container">
            <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                :gridOptions="gridOptions"
                @row-double-clicked="(params) => editPagingSubstitution(params.data)"
                :groupHeaders="true"
                :rowHeight="40">
            </ag-grid-vue>
        </div>

        <v-btn color="#c42111" class="mt-3 mr-3" @click="addNewPagingSubstitution" :disabled="lockSave">New</v-btn>
        <v-btn color="#c42111" class="mt-3 mr-3" @click="saveClick" :disabled="lockSave || !$store.state.isDirty">Save</v-btn>

        <v-dialog v-model="showSubstitutionEdit" max-width="80%" width="400px" persistent @keydown="(k) => {k.key == 'Escape' ? showSubstitutionEdit = false : null}">
            <paging-substitution-edit :pagingSubstitution="selectedSubstitutionClone" :usersList="usersList" :groupsList="groupsList" v-if="showSubstitutionEdit" @ok="applySubstitutionEdit" @cancel="showSubstitutionEdit = false"></paging-substitution-edit>
        </v-dialog>

    </v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import PagingSubstitutionEdit from "@/components/PagingSubstitutions/PagingSubstitutionEdit";
export default {
    name: 'PagingSubstitutions',
    props: [''],
    components: {
        'ag-grid-vue': AgGridVue,
        PagingSubstitutionEdit
    },
    data: () => ({
        showGrid: false,
        gridOptions: {},
        substitutionsList: [],
        lockSave: false,
        selectedSubstitution: null,
        selectedSubstitutionClone: null,
        showSubstitutionEdit: false,
        usersList: [],
        groupsList: []
    }),

    computed: {

    },

    methods: {
        getPageData() {
            let promises = [];
            promises.push(this.getSubstitutionsList());
            promises.push(this.getGroupsList());
            return promises;
        },

        getSubstitutionsList() {
            this.showGrid = false;
            let route = (TELSA.apiHost + "pagingsubstitutions/list");
            return this.$http.get(route).then(response => {
                let results = response.body;
                this.substitutionsList = results;
            });
        },

        getGroupsList() {
            let route = (TELSA.apiHost + "usergroups/list");
            return this.$http.get(route).then(response => {
                let result = response.body;
                console.log(result)
                this.usersList = result.users_list;
                this.groupsList = result.user_groups_list;
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.substitutionsList;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                //self.gridOptions.columnApi.autoSizeColumns();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'pagingSubstitutions');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            // Set the row text color if the substitution time has already passed
            this.gridOptions.getRowStyle = function(params) {
                if(!!params.data.ps_begin && !!params.data.ps_end) {
                    let start = TELSA.moment(params.data.ps_begin);
                    let end = TELSA.moment(params.data.ps_end);
                    let current = TELSA.moment.tz(self.$store.state.batchConfig.timezone);
                    if(end < current) {
                        return {
                            color: 'red'
                        };
                    }
                    else if(current < start) {
                        return {
                            color: 'green'
                        };
                    }
                    else {
                        return {
                            fontWeight: 'bold'
                        };
                    }
                }
            }

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle paging-substitute-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle paging-substitute-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.paging-substitute-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.paging-substitute-action')[1];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            if(!self.lockSave) {
                                this.editPagingSubstitution(params.data);
                            }
                        },
                        deleteFunction: (params) => {
                            if(!self.lockSave) {
                                this.deletePagingSubstitution(params.data);
                            }
                        }
                    }
                },
                { 
                    headerName: 'Begin', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return TELSA.moment(params.data.ps_begin).format('YYYY-MM-DD HH:mm:ss');
                    }
                },
                { 
                    headerName: 'End', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return TELSA.moment(params.data.ps_end).format('YYYY-MM-DD HH:mm:ss');
                    }
                },
                { 
                    headerName: 'Original User', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.user_id ?  self.lookupUserFromUserId(params.data.user_id).user_fullname : '';
                    }
                },
                { 
                    headerName: 'Substitute User', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.subst_user_id ? self.lookupUserFromUserId(params.data.subst_user_id).user_fullname : '';
                    }
                },
                { 
                    headerName: 'Original Group', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.group_id ? self.lookupGroupFromGroupId(params.data.group_id).group_name : '';
                    }
                },
                { 
                    headerName: 'Substitute Group', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.subst_group_id ? self.lookupGroupFromGroupId(params.data.subst_group_id).group_name : '';
                    }
                },
            ];
            return columnDefs;
        },

        lookupUserFromUserId: function(userId) {
            return this.usersList.find(user => {
                return (user.user_id == userId);
            });
        },

        lookupGroupFromGroupId: function(groupId) {
            return this.groupsList.find(group => {
                return (group.group_id == groupId);
            });
        },

        editPagingSubstitution: function(pagingSubstitution) {
            this.selectedSubstitution = pagingSubstitution;
            this.selectedSubstitutionClone = JSON.parse(JSON.stringify(pagingSubstitution));
            this.showSubstitutionEdit = true;
        },

        deletePagingSubstitution: function(pagingSubstitution) {
            let index = this.substitutionsList.indexOf(pagingSubstitution);
            this.substitutionsList.splice(index, 1);
        },

        addNewPagingSubstitution: function() {
            this.selectedSubstitutionClone = {
                ps_id: -1,
                ps_begin: null,
                ps_end: null,
                substitution_type: 'user',
                user_id: null,
                subst_user_id: null,
                group_id: null,
                subst_group_id: null
            };
            this.showSubstitutionEdit = true;
        },

        applySubstitutionEdit: function(pagingSubstitution) {
            if(pagingSubstitution.ps_id == -1) {
                pagingSubstitution.ps_id = 0;
                this.substitutionsList.push(pagingSubstitution);
            }
            else {
                this.substitutionsList[this.substitutionsList.indexOf(this.selectedSubstitution)] = this.selectedSubstitutionClone;
                this.substitutionsList.splice(0,0);
            }
            this.showSubstitutionEdit = false;
        },

        saveClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: 'Are you sure you want to commit your changes to the paging substitutions?',
                type: '',
                confirmAction: () => { this.save(); }
            });
        },

        save: function() {
            // Format dates
            for(let sub of this.substitutionsList) {
                sub.ps_begin = TELSA.moment(sub.ps_begin).format('YYYY-MM-DD HH:mm:ss');
                sub.ps_end = TELSA.moment(sub.ps_end).format('YYYY-MM-DD HH:mm:ss');
            }

            let route = (TELSA.apiHost + "pagingsubstitutions/list");
            TELSA.loading(true);
            return this.$http.post(route, {args: {lock: this.$store.state.lock, substitutionsList: this.substitutionsList}}).then(response => {
                let result = response.body;
                this.$store.commit('setIsDirty', false);
                TELSA.loading(false);
            });
        }
    },

    watch: {
        substitutionsList: {
            handler(newVal, oldVal) {
                if(this.gridOptions.api) {
                    if(!this.$props.lockSave) {
                        this.$store.commit('setIsDirty', true);
                    }
                    this.gridOptions.api.setRowData(this.substitutionsList);
                }
            },
            deep: true
        }
    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/alarm/paging-substitutions');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){Promise.all(self.getPageData()).then(r => {TELSA.loading(false); self.buildAgGrid();})}
            });
            this.lockSave = true;
            return;
        }

        let lockName = `edit_subst`;
        this.$store.dispatch('getLock', lockName).then(lockOwner => {
            Promise.all(this.getPageData()).then(v => {
                TELSA.loading(false);
                this.buildAgGrid();

                if(lockOwner) {
                    // Disable save and let user know page is locked!
                    this.lockSave = true;
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `The Paging Substitutions is already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                }
            });
        });

    }

  
};
</script>

<style scoped>

    #ag-grid-container {
        height: calc(100vh - 126px);
    }

</style>